/* unplugin-vue-components disabled */import script from "./ContentScraping.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentScraping.vue?vue&type=script&lang=ts&setup=true"

import "./ContentScraping.vue?vue&type=style&index=0&id=5ef92791&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ef92791"]])

export default __exports__